"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterButtonOverlay = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _hooks = require("../../hooks");
var _space = require("../../styles/variables/_space");
var _utils = require("../../utils");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _ButtonDropdown = require("../ButtonDropdown");
var _Tooltip = require("../Tooltip");
var _FilterButtonOverlayModule = _interopRequireDefault(require("./FilterButtonOverlay.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FilterButtonOverlay = exports.FilterButtonOverlay = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    anchorPosition = _ButtonDropdown.ANCHOR_POSITION_TYPE.bottomStart,
    positionStrategy = _ButtonDropdown.STRATEGY_TYPE.absolute,
    clickAwayRef,
    size = 'medium',
    children,
    isFluid,
    buttonLabel,
    buttonIsFluid,
    buttonSize,
    elevation = 'modal',
    testId,
    ...restProps
  } = _ref;
  const {
    x,
    y,
    refs,
    strategy,
    context
  } = (0, _react2.useFloating)({
    open: true,
    strategy: positionStrategy,
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });
  const dropdownWidth = (0, _hooks.useReferenceElementWidth)(refs.reference?.current);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_utils.ClickAway, {
    clickAwayRef: clickAwayRef,
    closeOnEscapeKeypress: true,
    containsNestedFloatingPortals: true,
    children: _ref2 => {
      let {
        isOpen,
        onOpen,
        boundaryRef,
        triggerRef
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'root'
        }),
        className: (0, _classify.default)({
          [_FilterButtonOverlayModule.default.isFluid]: buttonIsFluid
        }, classNames?.wrapper),
        ref: ref,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          ...restProps,
          ref: (0, _utils.mergeRefs)([refs.setReference, triggerRef]),
          onClick: e => {
            e.stopPropagation();
            onOpen();
          },
          isFluid: buttonIsFluid,
          size: buttonSize,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'button'
          }),
          children: buttonLabel
        }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingPortal, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
            modal: false,
            context: context,
            initialFocus: refs.reference,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: (0, _utils.mergeRefs)([refs.setFloating, boundaryRef]),
              className: _FilterButtonOverlayModule.default.overlayContainer,
              "data-testid": (0, _qa.generateTestId)({
                base: testId,
                slot: 'overlay'
              }),
              style: {
                display: 'flex',
                position: strategy,
                top: y ?? _space.spaceNone,
                left: x ?? _space.spaceNone,
                /* NOTE(Sharad): The FloatingPortal renders the menu outside the normal DOM structure,
                so its parent is effectively the <body> element. This means the menu
                would otherwise default to the body's width. To support fluid width,
                we must manually set the dropdown width here; otherwise, it uses a fixed width.
                Also, Only treat menu as non-fluid if isFluid is strictly false, since default is true in menu and undefined means fluid. */
                ...(isFluid !== false && {
                  '--dropdown-width': dropdownWidth
                }),
                '--menu-elevation': (0, _Tooltip.getElevationValue)(elevation)
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: (0, _classify.default)(_FilterButtonOverlayModule.default.overlayWrapper, {
                  [_FilterButtonOverlayModule.default.fluid]: isFluid,
                  [_FilterButtonOverlayModule.default.small]: size === 'small',
                  [_FilterButtonOverlayModule.default.medium]: size === 'medium'
                }, classNames?.overlayContainer),
                "data-testid": (0, _qa.generateTestId)({
                  base: testId,
                  slot: 'content'
                }),
                children: children
              })
            })
          })
        })]
      });
    }
  });
});